import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useAdminAuth } from '../../hooks/useAdmin';
import { Spinner } from '../ui';
import { theme } from '../../styles/theme';

interface AdminRouteProps {
  children: React.ReactNode;
}

/** Route guard that redirects non-admin users to the home page. */
export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const { data: isAdmin, isLoading: adminLoading } = useAdminAuth();

  // Show loading while checking auth
  if (authLoading || adminLoading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: theme.colors.bgPrimary,
        }}
      >
        <Spinner size="lg" />
        <p
          style={{
            marginTop: theme.spacing.md,
            color: theme.colors.textSecondary,
            fontSize: theme.fontSizes.sm,
            textAlign: 'center',
          }}
        >
          Verifying admin access...
        </p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to home if not an admin
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  // Render admin content
  return <>{children}</>;
};

export default AdminRoute;
